import toast from "react-hot-toast";
import { t } from "./theme";

// SayHi-flavored toast helpers — keep the call surface tiny and consistent.
// All toasts are short, single-instance per `id`, and inherit a unified style
// configured on <Toaster /> in App.jsx.

const baseId = (kind, msg) => `${kind}:${(msg || "").slice(0, 32)}`;

export const tSuccess = (msg, opts = {}) =>
  toast.success(msg, { id: opts.id || baseId("ok", msg), duration: 2000, ...opts });

export const tError = (msg, opts = {}) =>
  toast.error(msg, { id: opts.id || baseId("err", msg), duration: 2600, ...opts });

export const tInfo = (msg, opts = {}) =>
  toast(msg, {
    id: opts.id || baseId("info", msg),
    duration: 2200,
    icon: opts.icon ?? "💬",
    ...opts,
  });

// Re-export the raw toast for the rare case a caller needs custom rendering.
export { toast };

export const TOAST_STYLE = {
  duration: 2200,
  style: {
    borderRadius: 14,
    background: t.surface,
    color: t.ink,
    fontFamily: "'Plus Jakarta Sans', Inter, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    padding: "10px 14px",
    boxShadow: "0 8px 24px rgba(31,20,24,0.12)",
    maxWidth: 320,
    lineHeight: 1.4,
  },
  success: {
    iconTheme: { primary: t.success, secondary: "#FFF" },
  },
  error: {
    iconTheme: { primary: t.danger, secondary: "#FFF" },
  },
};
